<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <div class="c-smart-select" :class="focused?'active':''">
      <div class="c-smart-select__inner">
        <div class="c-smart-select__blank" @click="focus">
          {{ placeHolder }}
        </div>
        <i class="c-smart-select__icon icon12-opportunities-primary"></i>
        <div class="c-smart-select__current" @click="focus">
          <div v-if="multiple && selected && selected.length">
            <label v-for="item in selected" :key="item._id">
              <span>{{ item.name }} ({{ item.ext }})</span>
              <i class="fa fa-times" @click="remove(item)"></i>
            </label>
          </div>
          <label v-else-if="selected && !multiple">
            <span>{{ selected.name }} ({{ selected.ext }})</span>
            <i class="fa fa-times" @click="clear"></i>
          </label>
        </div>
        <div class="c-smart-select__ovelay">
          <input ref="searchBox" class="form-control form-control-sm" v-model="filterFormModel.keyword"
                 :placeholder="$t('typeToSearch')" @keyup="search" @click="focus" @focusout="focusOut" @keydown.esc="focusOut"/>
          <div class="c-smart-select__list" :class="focused?'active':''">
            <div v-if="firstLoading || listLoading" class="col-12 text-center">
              <b-spinner small></b-spinner>
            </div>
            <div class="col-12 text-center text-danger" v-else-if="!itemCount && !listLoading">
              <span>{{ $t('notFoundSearch') }}</span>
            </div>
            <ul>
              <li v-for="item in items" :key="item._id" @click="select(item)">
                <div class="c-smart-select-item is-multichoice">
                  <div class="animated-checkbox">
                    <label>
                      <input type="checkbox" :checked="model[attribute] && (item._id === model[attribute] || model[attribute].includes(item._id))">
                      <span class="label-text"></span>
                    </label>
                  </div>
                  <div class="c-smart-select-item__row">
                    <b>{{ item.name }}</b> ({{ item.ext }})<span class="badge badge-info ml-2">{{ getRoleName(item.role) }}</span>
                  </div>
                  <div class="c-smart-select-item__row">{{ item.email }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import list from '../mixins/List';
import _ from "lodash";
import i18n from '@/i18n';

export default {
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'user'
    },
    label: String,
    errors: Array,
    placeHolder: {
      type: String,
      default: i18n.t('selectUser')
    },
    multiple: Boolean,
    groupFilter: String,
    groupsFilter: Array,
    roleFilter: String,
    rolesFilter: Array,
    doctorGroupFilter: String,
  },
  mixins: [list],
  data() {
    return {
      selected: null,
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: 'user',
      autoLoad: false,
      defaultFilterFormModel: {
        keyword: '',
        status: 0
      },
      focused: false,
      changeTrigger: true,
      afterLoad: this.loadNhomNVYT,
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        if (val[this.attribute] != null) {
          if (this.changeTrigger) {
            this.loadSelected();
          }
          this.changeTrigger = true;
        } else {
          this.selected = null;
        }
      }, deep: true
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    list() {
      this.showList = true;
      this.load();
    },
    loadSelected() {
      if (this.model[this.attribute]) {
        let ids;
        if (this.multiple) {
          ids = this.model[this.attribute].join(',');
        } else {
          ids = this.model[this.attribute];
        }
        this.$bgService.get('/user', {
          params: {page: 1, pageSize: 200, ids: ids}
        }).then(response => {
          if (this.multiple) {
            this.selected = response.data.docs;
          } else if (response.data.docs.length) {
            this.selected = response.data.docs[0];
          }
        });
      }
    },
    select(item) {
      if (this.multiple) {
        if (!this.selected) {
          this.selected = [];
        }
        if (!this.model[this.attribute]) {
          this.model[this.attribute] = [];
        }
        if (!this.model[this.attribute].includes(item._id)) {
          this.selected.push(item);
          this.model[this.attribute].push(item._id);
        }
      } else {
        this.selected = item;
        this.model[this.attribute] = item._id;
      }
      this.changeTrigger = false;
      this.focused = false;
      this.$emit('change');
    },
    clear() {
      this.selected = null;
      this.model[this.attribute] = null;
      this.changeTrigger = false;
      this.$emit('change');
    },
    remove(item) {
      if (this.multiple && this.model[this.attribute].includes(item._id)) {
        this.model[this.attribute] = this.model[this.attribute].filter(i => i !== item._id);
        this.selected = this.selected.filter(i => i._id !== item._id);
        this.changeTrigger = false;
        this.$emit('change');
      }
    },
    focus() {
      if (!this.focused) {
        this.filterFormModel.keyword = '';
        this.focused = true;
        this.$refs.searchBox.focus();
        if (this.roleFilter) {
          this.filterFormModel.role = this.roleFilter
        }
        if (this.rolesFilter) {
          this.filterFormModel.roles = this.rolesFilter
        }
        if (this.groupsFilter) {
          this.filterFormModel.groups = this.groupsFilter.join(",")
        }
        if (this.groupFilter) {
          this.filterFormModel.group = this.groupFilter
        } else {
          this.filterFormModel.group = null
        }
        if (this.doctorGroupFilter) {
          this.service = '/nhom-nvyt'
          this.filterFormModel.doctorUser = this.doctorGroupFilter
        }
        this.load();
      }
    },
    focusOut: _.debounce(function () {
      this.focused = false;
    }, 150),
    search: _.debounce(function () {
      this.load();
    }, 200),
    getRoleName(key) {
      if (['owner', 'supervisor', 'agent'].includes(key)) {
        return this.$t(key);
      }
      let role = this.$store.state.roles.find(r => r.key === key);
      if (role && role.name) {
        return role.name
      }
      return key
    },
    loadNhomNVYT() {
      if (this.doctorGroupFilter) {
        this.items = this.items[0] ? this.items[0].followUsers : []
      }
    }
  },
  mounted() {
    this.selected = null;
    this.loadSelected();
  }
}
</script>
